<template>
    <div class="container bg-light position-fixed top-50 start-50 translate-middle w-75 border border-danger p-3"
        style="border-radius: 10px">
        <div class="container overflow-auto w-100" style="max-height:80vh">
            <div class="container table-responsive">
                <button class="btn-close float-end me-2 mt-1" @click.prevent="close"></button>
                <h3 class="mt-3"><strong> Información previa del tramo completo </strong></h3>
                <table class="table table-bordered my-auto mx-auto">
                    <tbody>
                        <tr>
                            <th>Presentación:</th>
                            <th>{{ completeSectionInfo.presentation }}</th>
                            <th>Especificación:</th>
                            <td>{{ completeSectionInfo.specification }}</td>
                        </tr>
                        <tr>
                            <th>Clasificación:</th>
                            <td><i>{{ completeSectionInfo.sheetType }}</i></td>
                            <th>Dimensiones del <br> tramo completo:</th>
                            <td><i>{{ completeSectionInfo.dimensions }}</i></td>
                        </tr>
                        <tr>
                            <th>Ancho en <i>metros</i>:</th>
                            <td>{{ widthMeters }}</td>
                            <th>Largo en <i>metros</i>:</th>
                            <td>{{ lengthMeters }}</td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                <h3 class=""> <strong>
                                        Editar tramo completo
                                    </strong></h3>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="4">
                                <p><strong>Nota: </strong><mark>No podrá editar la clasificación del tramo completo.</mark>
                                </p>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p> <i class="requiredFields">* </i>Nueva Presentación / Especificación:</p>
                            </td>
                            <td colspan="2">
                                <select class="form-select" id="sheetPstAndSpc" v-model="editPstAndSpc"
                                    @change="trimPresentationAndSpecification(this.editPstAndSpc)">
                                    <option value="0" selected>Seleccione una opción...</option>
                                    <option value="LISA HR / ASTM A-36">LISA HR / ASTM A-36</option>
                                    <option value="LISA CR / ASTM A-366">LISA CR / ASTM A-366</option>
                                    <option value="LISA CR GALVANIZADA / ASTM A-366">LISA CR GALVANIZADA / ASTM
                                        A-366</option>
                                    <option value="CORRUGADA (ALFAJOR) / ASTM A-589">CORRUGADA (ALFAJOR) / ASTM
                                        A-589</option>
                                    <option value="LISA INOXIDABLE OPACA / AISI - SAE  304  T1">LISA INOXIDABLE
                                        OPACA / AISI - SAE 304
                                        T1</option>
                                    <option value="CURRUGADA (ALFAJOR) ALUMINIO / AISI - ASTM 6061">CURRUGADA
                                        (ALFAJOR) ALUMINIO / AISI
                                        - ASTM 6061</option>
                                    <option value="LISA ANTIDESGASTE / ASTM L2  MAXDUR  450 - 500">LISA ANTIDESGASTE
                                        / ASTM L2 MAXDUR
                                        450 - 500</option>
                                </select>
                            </td>
                            <td>
                                <mark><input class="form-check-input" type="checkbox" role="switch" id="notChangePstAndSpc"
                                        v-model="notChangePstAndSpc" />
                                    <i> Mantener Presentación/Especificación previos.</i></mark>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p> <i class="requiredFields">* </i>Nuevas dimensiones:</p>
                            </td>
                            <td colspan="2">
                                <input type="text" v-model="editDimensions" class="form-control" id="editDimensions" />
                            </td>
                            <td>
                                <mark><input class="form-check-input" type="checkbox" role="switch" id="notChangeDimensions"
                                        v-model="notChangeDimensions" />
                                    <i> Mantener dimensión previa del tramo completa.</i></mark>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <p><i class="requiredFields">* </i> Nuevo precio asociado:</p>
                            </td>
                            <td colspan="2">
                                <select class="form-select" id="price_id" v-model="editPriceId">
                                    <option selected value="0">Opciones disponibles...</option>
                                    <option v-for="price in pricesList" :key="price._id" v-bind:value="price.id">
                                        {{ price.name }}
                                    </option>
                                </select>
                            </td>
                            <td>
                                <mark><input class="form-check-input" type="checkbox" role="switch" id="notChangePrice"
                                        v-model="notChangePrice" />
                                    <i> Mantener precio asociado previo.</i></mark>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <button class="btn btn-danger my-3" @click.prevent="saveChanges">
                Actualizar tramo completo
            </button>
        </div>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_BACKEND;
export default {
    props: {
        getCompSectionIdToEdit: Number,
    },
    data() {
        return {
            priceDefault: "lam",
            pricesList: [],
            completeSectionInfo: [],
            dimensions: "",
            widthMeters: 0,
            lengthMeters: 0,
            //Fields
            editPstAndSpc: "",
            editPresentation: "",
            editSpecification: "",
            editDimensions: "",
            editPriceId: 0,
            //Campos que pueden cambiar o no
            notChangePstAndSpc: false,
            notChangeDimensions: false,
            notChangePrice: false,
        }
    },
    watch: {
        getCompSectionIdToEdit(newVal) {
            if (newVal !== null) {
                this.getCompleteSectionInfo();
            }
        },
    },
    methods: {
        trimPresentationAndSpecification(presentationSpecification) {
            let variables = presentationSpecification.split('/');
            this.editPresentation = variables[0].trim();
            this.editSpecification = variables[1].trim();
        },
        close() {
            this.completeSectionInfo = [];
            this.$emit("hideEditCompSection", false);
        },
        getCompleteSectionInfo() {
            try {
                axios.get(RUTA_SERVIDOR + "api/sheet/dimension/get", {
                    params: {
                        sheetDimension_id: this.getCompSectionIdToEdit,
                    },
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                })
                    // .then((res) => console.log(res.data[0]))
                    .then((res) => {
                        // Verificar que hay datos en la respuesta
                        if (res.data && res.data.length > 0) {
                            // Acceder a la respuesta del servidor y asignar valores
                            this.completeSectionInfo = res.data[0];
                            this.dimensions = this.completeSectionInfo.dimensions;

                            // Log después de recibir la respuesta
                            // console.log(this.dimensions);

                            // Verificar que las dimensiones son válidas antes de intentar dividirlas
                            if (this.dimensions) {
                                // Separar las dimensiones
                                let singleDim = this.dimensions.split("x");
                                this.widthMeters = parseFloat(singleDim[0].trim()) / 1000;
                                this.lengthMeters = parseFloat(singleDim[1].replace("mm", "").trim()) / 1000;
                            }
                        } else {
                            console.log("La respuesta del servidor no contiene datos.");
                        }
                    })
                    .catch((err) => console.log(`There has been an error ${err}`));
            } catch (err) {
                console.log(`An error has occurred: ${err}`);
            }
        },
        async saveChanges() {
            if (
                (!this.notChangeDimensions && this.editDimensions === "") ||
                (!this.notChangePstAndSpc && this.editPstAndSpc == "") ||
                (!this.notChangePrice && this.editPriceId == 0)
            ) {
                alert("Complete aquellos campos que son obligatorios marcados con *.")
                this.cleanFields();
            } else {
                let formData = new FormData();
                formData.append("sheet_dimension_id", this.completeSectionInfo.id);
                // formData.append("editType", this.editType);
                this.notChangeDimensions ? formData.delete("editDimensions") : formData.append("editDimensions", this.editDimensions);
                if (this.notChangePstAndSpc) {
                    formData.delete("editPresentation");
                    formData.delete("editSpecification");
                } else {
                    formData.append("editPresentation", this.editPresentation);
                    formData.append("editSpecification", this.editSpecification);
                }
                this.notChangePrice ? formData.delete("price_id") : formData.append("price_id", this.editPriceId);
                try {
                    let res = await axios.post(
                        RUTA_SERVIDOR + "api/sheet/dimension/update",
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data",
                                Authorization: "Bearer " + localStorage.getItem("token"),
                            },
                        }
                    );
                    //console.log(res.data);
                    if (!res.data) {
                        console.log("There has been a different error with the data.");
                    } else {
                        this.editPstAndSpc === "" ? alert("Cambios sobre el tramo completo aplicados con exito!") : alert("Tramo completo: " + this.editPresentation + " " + this.editSpecification + ", actualizado con exito!");
                    }
                } catch (err) {
                    console.log(`There has been an error ${err}`);
                }
                this.close();
                location.reload();
            }
        },
        cleanFields() {
            this.editPstAndSpc = "";
            this.editPriceId = 0;
            this.editDimensions = "";
            this.notChangeDimensions = false;
            this.notChangePrice = false;
            this.notChangePstAndSpc = false;
        }
    },
    mounted() {
        axios
            .get(RUTA_SERVIDOR + "api/price/list", {
                params: {
                    price_type: this.priceDefault,
                },
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("token"),
                },
            })
            .then((res) => (this.pricesList = res.data))
            .catch((err) => console.log(`There has been an error ${err}`));
    }
}
</script>
<style scoped>
.requiredFields {
    color: #9d0e15;
}
</style>